import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import DialogContent from '@mui/material/DialogContent';

const styles = theme => ({
    formControl: {
        width: '100%'
    },
    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});

/* Liste des réponses possibles */
const reponses = [
    'stock correct',
    'quantité trouvée non préparée',
    'mauvais produit à l\'emplacement',
    'produit non conforme'
];

class ControleStockDialogContent extends React.Component {

    state = {
        commentaire: "",
        resultat: null,
        codeArticle: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action} = this.props;

        if (newState.resultat === null) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.codeArticle)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: "CODE_ARTICLE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Code article",
                position: 0,
                valeurString: newState.codeArticle
            }]
        };

        {
            let detail = {
                code: "RESULTAT",
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Résultat du contrôle : ",
                position: actionData.details.length,
                valeurString: reponses[newState.resultat],
                valeurInteger: newState.resultat
            };
            actionData.details.push(detail);
        }

        if (newState.commentaire) {

            let detail = {
                code: "COMMENTAIRE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { commentaire, resultat, codeArticle } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="codeArticle"
                    name="codeArticle"
                    label="Code article"
                    placeholder="Code article"
                    multiline
                    margin="normal"
                    value={codeArticle}
                    onChange={this.handleChange}
                />

                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Résultat du contrôle : </FormLabel>
                    <RadioGroup
                        aria-label="controle"
                        name="resultat"
                        className={classes.group}
                        value={resultat}
                        onChange={this.handleChange}
                    >
                        {reponses.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}

                    </RadioGroup>
                </FormControl>
                
                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

ControleStockDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(ControleStockDialogContent);